// extracted by mini-css-extract-plugin
export default {"item":"ImageItem_item__GpMBv","name":"ImageItem_name__84JoP"};